<template>
  <div class="unassigned-reservations">
    <h3>Unassigned Reservations</h3>
    <button class="btn btn-secondary mb-3" @click="showGhostForm = !showGhostForm">
      {{ showGhostForm ? "Cancel Ghost" : "Add Ghost" }}
    </button>

    <ghost-reservation
      v-if="showGhostForm"
      @saveGhost="addGhostReservation"
      @cancelGhost="showGhostForm = false"
    />

    <unassigned-reservation
      v-for="reservation in unassignedReservations"
      :key="reservation.reservationid"
      :selected-date="selectedDate"
      :reservation="reservation"
      :trips="trips"
      @assignReservation="handleAssignment"
    />
  </div>
</template>

<script>
import UnassignedReservation from "./UnassignedReservation.vue";
import GhostReservation from "./GhostReservation.vue";

export default {
  components: {
    UnassignedReservation,
    GhostReservation,
  },
  props: {
    unassignedReservations: Array,
    trips: Array,
    selectedDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showGhostForm: false,
    };
  },
  methods: {
    handleAssignment(data) {
      this.$emit("reservationAssigned", data);
    },
    addGhostReservation(ghost) {
      // Emit the new ghost reservation to the parent
      this.$emit("addGhost", ghost);
      this.showGhostForm = false;
    },
  },
};
</script>

<style scoped>
.unassigned-reservations {
  padding: 1rem;
}

button {
  margin-bottom: 1rem;
}
</style>
